import React, { useState } from "react";
import "./style.scss";

interface PageProps {
	img: string;
	video: string;
	open: boolean;
	setOpen: any;
}

const ViewPhoto = ({ img, video, open, setOpen }: PageProps) => {
	if (open)
		return (
			<div
				className="view-photo-wrapper"
				onClick={() => {
					setOpen(false);
				}}
			>
				<div
					className="close-btn"
					onClick={() => {
						setOpen(false);
					}}
				>
					X
				</div>
				<div
					className="view-container"
					onClick={(e) => {
						e.stopPropagation();
					}}
				>
					{img && <img src={img} alt="" />}
					{video && <video src={video} autoPlay muted />}
				</div>
			</div>
		);
	return null;
};

export default ViewPhoto;
